<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script type="text/javascript">
import { IS_WECHAT_APP, IS_IOS_BROWSER } from '@/utils/device'
import api from '@/api'
import wx from 'weixin-js-sdk'
import axios from './axios'
export default {
  data () {
    return {
      token: ''
    }
  },
  methods: {
    // 初始化入口地址，用于微信分享
    initCurrentUrl () {
      if (IS_WECHAT_APP && IS_IOS_BROWSER) window.sessionStorage.setItem('initUrl', window.location.href)
      var url = window.sessionStorage.getItem('initUrl') || window.location.href
      axios.post(api.account.wxcode, { url: url }).then(response => {
        if (response.data.code === 200) {
          wx.config({
            debug: false,
            appId: response.data.data.appid,
            timestamp: response.data.data.timestamp,
            nonceStr: response.data.data.noncestr,
            signature: response.data.data.signature,
            jsApiList: [
              'onMenuShareAppMessage',
              'onMenuShareTimeline'
            ]
          })
        }
      })
    }
  },
  created () {
    this.initCurrentUrl()
  }
}
</script>

<style>
@import './css/app.css';
@import './css/style.css';

/* 进度条 */
#nprogress .bar.custom-bar {
  background: #1FC435;
}
</style>
